import React from "react";
import { AiOutlineCheckCircle } from "react-icons/ai";
import {
   ENTERPRISE_ANNUAL_NOTE,
   describeEnterpriseLimits,
   formatEnterprisePrice
} from "./enterprise";

// Enterprise among the billing page's plans (PlanPicker), drawn like the plan
// cards beside it, under them. It reads one of three ways (enterprise.js):
//
// - Terms to take up — an offer, or the terms the organization had: picked
//   like any plan, at their prices, in their currency.
// - Asked for, nothing offered yet: a note, and nothing to pick.
// - Neither: picked to ask for it, with no price. Nothing is charged.
//   `requestNote` says what happens next where it differs: the sign up asks
//   for it, and for what it should hold, on its review step.
const REQUEST_NOTE =
   "Prices and limits agreed with our team for your organization. Pick it to ask us to get in touch. Nothing is charged.";

function EnterpriseOption({
   terms,
   isRequested,
   isYearly,
   isSelected,
   onSelect,
   requestNote = REQUEST_NOTE
}) {
   if (!terms && isRequested) {
      return (
         <div className="package-choice__enterprise" role="status">
            <b>Enterprise requested — we'll be in touch</b>
            <p>Our team will contact you to agree the prices and limits of your Enterprise plan.</p>
         </div>
      );
   }

   const handleKeyDown = (event) => {
      if (event.key !== "Enter" && event.key !== " ") return;
      event.preventDefault();
      onSelect();
   };

   return (
      <div
         role="radio"
         tabIndex={0}
         aria-checked={isSelected}
         aria-label="Enterprise"
         onClick={onSelect}
         onKeyDown={handleKeyDown}
         className={`package-choice__plan package-choice__plan--organization${
            isSelected ? " package-choice__plan--selected" : ""
         }`}
      >
         <div className="package-choice__plan-head">
            <span className="package-choice__plan-radio" aria-hidden="true" />
            <span className="package-choice__plan-name">Enterprise</span>
         </div>
         {terms ? (
            <>
               <div className="package-choice__plan-price">
                  <b>{formatEnterprisePrice(terms, isYearly)}</b>
                  <small>/month</small>
               </div>
               {isYearly && <span className="package-choice__plan-terms">{ENTERPRISE_ANNUAL_NOTE}</span>}
               <span className="package-choice__plan-terms">
                  {isYearly
                     ? `Or ${formatEnterprisePrice(terms, false)}/month on the monthly plan.`
                     : `Or ${formatEnterprisePrice(terms, true)}/month on the annual plan, a 12-month commitment.`}
               </span>
               <ul className="package-choice__plan-limits">
                  {describeEnterpriseLimits(terms).map((limit) => (
                     <li key={limit}>
                        <AiOutlineCheckCircle />
                        <span>{limit}</span>
                     </li>
                  ))}
               </ul>
            </>
         ) : (
            <>
               <div className="package-choice__plan-price">
                  <b>Custom pricing</b>
                  <small>contact us</small>
               </div>
               <span className="package-choice__plan-terms">{requestNote}</span>
            </>
         )}
      </div>
   );
}

export default EnterpriseOption;
